import { useEffect } from 'react';

import { useRealtime } from '../hooks/realtime/useRealtime';

import { hasRealtimeChannel } from './utils/realtimeChannelHelper';

import { useRealtimeConnection } from './useRealtimeConnection';

import { useSalesDteSubscription } from './subscriptions/useSalesDteSubscription';
import { useSalesPrintSubscription } from './subscriptions/useSalesPrintSubscription';

import { usePurchasesDteSubscription } from './subscriptions/usePurchasesDteSubscription';
import { usePurchasesPrintSubscription } from './subscriptions/usePurchasesPrintSubscription';

import { useNotificationsSubscription } from './subscriptions/useNotificationsSubscription';
import { usePendingCashierSalesSubscription } from './subscriptions/usePendingCashierSalesSubscription';

export const useDynamicRealtimeSubscriptions = () => {

    // =====================================================
    // 🌐 SOCKET
    // =====================================================

    useRealtimeConnection();

    const {
        myChannels,
        handlerGetMyChannels,
    } = useRealtime();

    // =====================================================
    // 📡 CARGAR CANALES DEL USUARIO
    // =====================================================

    useEffect(() => {

        handlerGetMyChannels();

    }, []);

    // =====================================================
    // 📡 SALES
    // =====================================================

    useSalesDteSubscription({
        enabled: hasRealtimeChannel(
            myChannels,
            'SALES_DTE'
        ),
    });

    useSalesPrintSubscription({
        enabled: hasRealtimeChannel(
            myChannels,
            'SALES_PRINT'
        ),
    });

    usePendingCashierSalesSubscription({
        enabled: hasRealtimeChannel(
            myChannels,
            'PENDING_CASHIER_SALES'
        ),
    });

    // =====================================================
    // 📡 PURCHASES
    // =====================================================

    usePurchasesDteSubscription({
        enabled: hasRealtimeChannel(
            myChannels,
            'PURCHASE_DTE'
        ),
    });

    usePurchasesPrintSubscription({
        enabled: hasRealtimeChannel(
            myChannels,
            'PURCHASE_PRINT'
        ),
    });

    // =====================================================
    // 🔔 NOTIFICATIONS
    // =====================================================

    useNotificationsSubscription({
        enabled: hasRealtimeChannel(
            myChannels,
            'NOTIFICATIONS'
        ),
    });
};